import React from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import * as ReactRedux from 'react-redux';
import getSuperScriptValue from 'SelfServeBuilderUtils';
import classNames from 'classnames';
import { SelfServeBuilderPopupTypes } from 'Popups';
import SectionItem from './SectionItem';

export class GroupedChoiceSectionItem extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.doneEditingFieldPopups;
  }

  render() {
    const superscriptValue = getSuperScriptValue(
      this.props.fieldId,
      this.props.group.label,
      this.props.popupGroups,
    );
    const type = this.props.group.type;

    const groupIconClass = classNames(
      'checkbox-section-item-checkmark',
      {
        'multiple-choice': type === SelfServeBuilderPopupTypes.MULTIPLE_CHOICE,
      },
    );

    const superscript = superscriptValue > 0 ? <sup>{superscriptValue}</sup> : null;
    return (
      <SectionItem
        fieldId={this.props.fieldId}
        index={this.props.index}
      >
        <div className="section-item">
          <div className="checkbox-section-item-title">{this.props.group.label}{superscript}</div>
          {this.props.group.fieldIds.map(id => (
            <div
              key={id}
              className="checkbox-section-item-label"
            >
              <span className={groupIconClass} />
              {this.props.groupedPopups[id].label}
            </div>
          ))}
        </div>
      </SectionItem>
    );
  }
}

GroupedChoiceSectionItem.defaultProps = {
  fieldData: {},
  groupedPopups: {},
  isSample: false,
  label: '',
};

GroupedChoiceSectionItem.propTypes = {
  fieldId: PropTypes.string.isRequired,
  group: PropTypes.shape({
    fieldIds: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  groupedPopups: CustomPropTypes.hashmapOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  index: PropTypes.number.isRequired,
  popupGroups: PropTypes.shape({
    fieldIds: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = ({ SelfServeBuilderReducer }) => ({
  doneEditingFieldPopups: SelfServeBuilderReducer.popupCreationEnabled,
});

export default ReactRedux.connect(
  mapStateToProps,
)(GroupedChoiceSectionItem);



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SectionOrganizer/GroupedChoiceSectionItem.jsx